import React from 'react'

const ProjectsIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Clipboard Frame */}
      <path d="M51.86,4V60H12.14V4H51.86m4-4H8.14V64H55.86V0Z" />

      {/* Top Clip */}
      <path d="M40.71,4V7H23.29V4H40.71m4-4H19.29V11H44.71V0Z" />

      {/* Project Row 1 */}
      <rect x="14.71" y="15.51" width="12.26" height="12.26" />
      <rect x="30.01" y="19.64" width="18.73" height="4" />

      {/* Project Row 2 */}
      <rect x="14.71" y="29.81" width="12.26" height="12.26" />
      <rect x="30.01" y="33.94" width="18.73" height="4" />

      {/* Project Row 3 (Checkbox Style) */}
      <path d="M23,48.12v4.26H18.71V48.12H23m4-4H14.71V56.38H27V44.12Z" />
      <rect x="30.01" y="48.25" width="18.73" height="4" />
    </svg>
  )
}

export default ProjectsIcon
